// extracted by mini-css-extract-plugin
module.exports = {"component":"Brands_component__7f7HC","on3":"Brands_on3__tSje3","rivals":"Brands_rivals__E45XX","divider":"Brands_divider__iFzcl","small":"Brands_small__AIezb"};